module.exports = __webpack_public_path__ + "static/media/hippo.0e379cd9.svg";